import React, {useState, useEffect, useRef} from 'react';
import {mrbgStore, redFldToWhite, selectTagNum, selectTagValue} from './mrbgRedux';

// VIRTUAL SELECT TAG __________________________________________________________________________________________________
function MrbgSelect({formID,name,optVarName,firstOptLabel,mode,referenceSelect,fillFormKeys,setFillFormKeys,other,defaultClass,iconMode,formStyle}){

	const
		MRBGST  = useRef(null),
		[options, setOptions] =
			useState(
				referenceSelect?
					mrbgStore.getState().formsSettings[formID].STV[referenceSelect]?.length?
						mrbgStore.getState().mrbgVars[optVarName][mrbgStore.getState().formsSettings[formID].STV[referenceSelect][0]]:
						[]:
				mrbgStore.getState().mrbgVars[optVarName]
			),
		[mstCls, setMstCls]         = useState([formStyle.mrbgSelect, formStyle.minimize, ...( defaultClass? defaultClass.map(cls => formStyle[cls]): [] )]),
		[maxHeight, setMaxHeight] = useState(0),
		[ocIcon, setOcIcon]        = useState('fa-regular fa-angle-down'),
		[values, setValues]               = useState(mrbgStore.getState().formsSettings[formID]?.STV[name] || []),
		[numbers, setNumbers]             = useState(mrbgStore.getState().formsSettings[formID]?.STN[name] || []),
		[labels, setLabels]               = useState(firstOptLabel),        // FOR SINGLE MODE
		[formsSetting, setFormsSetting]   = useState(mrbgStore.getState().formsSettings[formID]);

	if( options===undefined )
		console.log(formID,name,optVarName)


	// openClose: only toggles state and icons, calculates maxHeight using the newMstCls
	// IMPORTANT: it no longer attaches/removes document listeners here — an effect below manages outside clicks
	function openClose(){
		if( formsSetting?.disabled.includes(name) )
			return false;

		let
			i         = mstCls.indexOf(formStyle.minimize),
			newMstCls = [...mstCls];

		if( arguments.length ){
			const arg = String(arguments[0]).toLowerCase();
			if( arg == 'o' && !MRBGST.current?.classList.contains('disabled') && i> -1 )
				newMstCls.splice(i, 1);
			else if( arg == 'c' && i == -1 )
				newMstCls.push(formStyle.minimize);
		}
		else if( i> -1 && !MRBGST.current?.classList.contains('disabled') ){
			newMstCls.splice(i, 1);
		}
		else if( i == -1 ){
			newMstCls.push(formStyle.minimize);
		}

		// apply new class array
		setMstCls(newMstCls);

		// calculate maxHeight based on the actual UL element (if found)
		const ulEl = MRBGST.current?.querySelector('.'+formStyle.mrbgSelectList+'>ul');
		if( ulEl ){
			const pos = ulEl.getBoundingClientRect();
			if( window.scrollY+pos.bottom>document.documentElement.scrollHeight ){
				setMaxHeight(Math.max(Math.floor(( document.documentElement.scrollHeight-window.scrollY-pos.top-5 )/30)*30, 120));
			}
			else if( newMstCls.includes(formStyle.minimize) ){
				setMaxHeight(0);
			}
		}
		else{
			// fallback: if closed -> reset height
			if( newMstCls.includes(formStyle.minimize) )
				setMaxHeight(0);
		}

		if( newMstCls.includes(formStyle.minimize) )
			setOcIcon('fa-regular fa-angle-down')
		else
			setOcIcon('fa-regular fa-angle-up');
	}
	function handleClickOutside(e){
		if( MRBGST.current && !MRBGST.current.contains(e.target) && !mstCls.includes(formStyle.minimize) ){
			// close without manipulating document listeners here
			openClose('C');
		}
	}

	useEffect(() => {
		if( !mstCls.includes(formStyle.minimize) ){
			document.addEventListener('mousedown', handleClickOutside);
			return () => document.removeEventListener('mousedown', handleClickOutside);
		}
	},[mstCls])
	useEffect(() => {
		if( !mode || !['multi', 'arrayMulti'].includes(mode) ){
			values[0]?
				setLabels(options[values[0]]):
				setLabels(Array.isArray(firstOptLabel)? firstOptLabel[0]: firstOptLabel)
			openClose('C');
		}

		if( formsSetting?.redFld.includes(name) && values.length && values[0] != '' )
			mrbgStore.dispatch(redFldToWhite({formID, name}));

		if( fillFormKeys && Object.keys(fillFormKeys).includes(name) && values[0]!==undefined && fillFormKeys[name]!==values[0] ){
			setFillFormKeys(
				{
					...fillFormKeys,
					[name]: values[0] || []
				}
			)
		}
	}, [values])
	useEffect(() => {
		if( other?.myFunc && formsSetting.STV[name] ){
			other.myFunc(MRBGST.current)
		}
	}, [formsSetting.STV[name]]);
	useEffect(() => {
		const unsubscribe = mrbgStore.subscribe(() => {
			setOptions(
				referenceSelect?
					mrbgStore.getState().formsSettings[formID].STV[referenceSelect]?.length?
						mrbgStore.getState().mrbgVars[optVarName][mrbgStore.getState().formsSettings[formID].STV[referenceSelect][0]]:
						[]:
					mrbgStore.getState().mrbgVars[optVarName]
			)
			setFormsSetting(mrbgStore.getState().formsSettings[formID])
			setValues(mrbgStore.getState().formsSettings[formID]?.STV[name] || [])
			setNumbers(mrbgStore.getState().formsSettings[formID]?.STN[name] || [])
		})
		return () => unsubscribe();
	}, []);

	return (
		<>
			<div data-type="mrbgSelect" className={`${mstCls.join(' ')} ${formsSetting?.disabled?.includes(name)? formStyle.disabled: ''} ${formsSetting?.redFld.includes(name)? formStyle.emptyField: ''}`} name={name} ref={MRBGST}>
				<div className={formStyle.mrbgSelectValue} onClick={() => openClose()}>
					<span>{labels}</span>
					<i className={ocIcon}></i>
				</div>
				{
					mstCls.includes(formStyle.minimize)?
						'':
						<MrbgSelectOptions {...{ formID, name, firstOptLabel, mode, values, options, mstCls, maxHeight, iconMode, formStyle }} />
				}
			</div>
			{
				mode == 'multi'?
					<MrbgSelect_MHI {...{ formID, name, values, options, formStyle }}/>:
					mode == 'arrayMulti'?
						<MrbgSelect_MTI {...{ formID, name, values, options, numbers, formsSetting, formStyle }}/>:
						<MrbgSelect_SHI {...{ formID, name, values, options }}/>
			}
		</>
	);
}

// VIRTUAL LIST ____________________________________________________________________________________________________
function MrbgSelectOptions({formID,name,firstOptLabel,mode,values,options,mstCls,maxHeight,iconMode,formStyle}){

	const
		searchInp = useRef(),
		[searchVal, setSearchVal] = useState(''),
		searchPat = new RegExp('(^|\\s+|\\(|\\[|\\.)'+searchVal.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'iu');

	function clickOpt( val, mode ){
		if( ['multi', 'arrayMulti'].includes(mode) ){
			if( val )
				values.some(k => k == val)?
					mrbgStore.dispatch(selectTagValue({formID, STName:name, value:values.filter(item => item != val)})):
					mrbgStore.dispatch(selectTagValue({formID, STName:name, value:[...values, val]}));
		}
		else{
			val?
				mrbgStore.dispatch(selectTagValue({formID, STName:name, value:[val]})):
				mrbgStore.dispatch(selectTagValue({formID, STName:name, value:[]}));
		}
	}

	useEffect(() => {
		mstCls.includes(formStyle.minimize)?
			setSearchVal(''):
			searchInp.current?.focus()
	}, [mstCls])

	let classes = [formStyle.mrbgSelectAble];

	return (
		<div className={formStyle.mrbgSelectList}>
			<div className={formStyle.mrbgSelectSearch}>
				<input name="MSF" type="search" value={searchVal} tabIndex={0} onChange={e => e.nativeEvent.inputType==='insertFromPaste'? setSearchVal(e.target.value.replace(/جلسه \d+/,'').trim()): setSearchVal(e.target.value)} ref={searchInp}/>
			</div>
			<ul style={maxHeight? { maxHeight: maxHeight }: {}}>
				{
					values.length && values[0]?
						<li className={classes.join(' ')} onClick={() => clickOpt('', mode)} title={firstOptLabel} key={0}>{firstOptLabel}</li>:
						<li className={classes.concat(formStyle.mrbgSelected).join(' ')} onClick={() => clickOpt('', mode)} title={firstOptLabel} key={0}>{firstOptLabel}</li>
				}
				{
					Object.keys(options).map(( key, i ) => {
						let
							title   = options[key].toString().replace(/(\\[\\d+\\])/g, '').trim(),
							classes = [formStyle.mrbgSelectAble];

						if( searchPat && !searchPat.test(title) )
							classes.push(formStyle.mrbgHideOption);

						if( values.some(k => k == key) )
							( mode && ['multi', 'arrayMulti'].includes(mode) )?
								classes.push(formStyle.msChecked):
								classes.push(formStyle.mrbgSelected);

						if( iconMode )
							classes.push(key)

						return (
							<li data-value={key} className={classes.join(' ')} onClick={() => clickOpt(key, mode)} title={title} key={i+1}>{options[key]}</li> )
					})
				}
			</ul>
		</div>
	)
}

// SINGLE HIDE INPUT ___________________________________________________________________________________________________
function MrbgSelect_SHI({formID,name,values,options}){

	function changeHandle( val ){
		( val == '' || options.length == 0 || !Object.keys(options).includes(val) )?
		mrbgStore.dispatch(selectTagValue({formID, STName:name, value:[]})):
		mrbgStore.dispatch(selectTagValue({formID, STName:name, value:[val]}));
	}

	return <input type="hidden" name={name} value={values[0] || ''} onInput={e => changeHandle(e.target.value.trim())}/>
}

// MULTI HIDE INPUT ____________________________________________________________________________________________________
function MrbgSelect_MHI({formID,name,values,options,formStyle}){

	function removeTag( val ){
		mrbgStore.dispatch(selectTagValue({formID, STName:name, value:values.filter(item => item != val)}));
	}

	return (
		<>
			{
				values.length?
					values.map(( val, i ) => {
						return (
							<React.Fragment key={i}>
								<label className={formStyle.mrbgTag}>
									{options[val]}
									<i className="fa-regular fa-times-circle" onClick={() => removeTag(val)}></i>
								</label>
								<input className={formStyle.mrbgHiddenCheckbox} type="checkbox" name={`${name}[]`} value={val} defaultChecked/>
							</React.Fragment>
						)
					}):
					''
			}
		</>
	)
}

// MULTI TABLE INPUT ___________________________________________________________________________________________________
function MrbgSelect_MTI({formID,name,values,options,numbers,formSetting,formStyle}){
	function removeTr( val ){
		var newN    = [...numbers];
		const index = values.indexOf(val);
		if( index> -1 )
			newN.splice(index, 1);
		mrbgStore.dispatch(selectTagValue({formID, STName:name, value:values.filter(item => item != val), num:newN}));
	}

	function changeInpVal( val, key ){
		var newNum  = [...numbers];
		newNum[key] = val;
		mrbgStore.dispatch(selectTagNum({formID, STName:name, value:newNum}))
	}

	return (
		<>
			{
				values.length && values[0]?
				<table className={formStyle.msnTable}>
					<tbody>
					{
						values.map(( val, i ) => {
							return (
								<tr key={i}>
									<td>
										<label className={formStyle.mrbgTag}>
											{options[val]}
											<i className="fa-regular fa-times-circle" onClick={() => removeTr(val)}></i>
										</label>
										<input className={formStyle.mrbgHiddenCheckbox} type="checkbox" name={name+'[]'} value={val} defaultChecked/>
									</td>
									<td>
										<input type="number" name={name+'__num[]'} value={numbers[i] || ''}
													 className={formSetting?.redFld.includes(name+'__num['+i+']')? 'emptyField': ''}
													 placeholder={'مقدار '+options[val]} onChange={e => changeInpVal(e.target.value, i)}/>
									</td>
								</tr>
							)
						})
					}
					</tbody>
				</table>:
				''
			}
		</>
	)
}

export default MrbgSelect;
